import React, { useContext, useEffect } from "react";

import { SocketContext, TableContext, TeamContext, UserContext } from "../../../../context";
import { PlayersSolutionCardsMolecule } from "../../../molecules";
import { useSound, useProposedSolutionCards } from "../../../../hooks";
import { Phase } from "../../../../util/enums";

import { ChosenDilemmaCard } from ".";

interface IRenderQuestionToDisplay {
    dilemmaOwnerImage: any,
    challengeCard: any
}

export const RenderQuestionToDisplayMemo: React.FC<IRenderQuestionToDisplay> = ({ dilemmaOwnerImage, challengeCard }) => {
    const { theSolutionCardSelectedByDilemmaOwner, solutionCardSelectedSocketOn } = useContext(SocketContext);
    const { isDilemmaChosen } = useContext(TableContext);
    const { game, numberOfPlayers} = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const [proposedSolutionCardsArray] = useProposedSolutionCards();
    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;

    const isAnimationForDragAndDropSolutionToStrengthShown = game?.phase === Phase.CHOOSE_SOLUTION && isTheUserDilemaOwner;
    const pulsingCurcleDivStyle = isAnimationForDragAndDropSolutionToStrengthShown? "solutions_proposed_wrapper_animation" : "";
    const {playSound} = useSound();

    useEffect(() => {
        solutionCardSelectedSocketOn();
    }, [solutionCardSelectedSocketOn])

    const renderProposedSolutions = () => {
        return (
            <div className={`solutions_proposed_wrapper`}>
                {isAnimationForDragAndDropSolutionToStrengthShown && <div className={pulsingCurcleDivStyle}></div>}
                {proposedSolutionCardsArray.map((solutionCard: any, index: number) => {
                    if(theSolutionCardSelectedByDilemmaOwner){
                        const cardDimentions = {width: `17vw`, height: `22.5vw`};
                        //TAGUJEM
                        if(theSolutionCardSelectedByDilemmaOwner === solutionCard?.card?.id){
                            return (
                                <div className={`solutions_proposed_card solution_card_that_dilemma_owner_selected` }
                                    style={{transform: "rotate(0deg)", zIndex: 1}}
                                    key={index}
                                    onMouseEnter={() => playSound("/sounds/ItemHover.mp3")}
                                >
                                    <PlayersSolutionCardsMolecule selectedCard={solutionCard} cardDimentions={cardDimentions} />
                                </div>
                            );
                        }
                        return <div key={index}></div>;
                    }

                    const cardDimentions = {width: `10vw`, height: `13.1vw`};

                    return (
                        <div className={`solutions_proposed_card ${ (numberOfPlayers === 4 && index === 1 ) ? "index_class--2-four-players" : 'index_class--'.concat(index.toString())}`}
                            key={index}
                            onMouseEnter={() =>playSound("/sounds/ItemHover.mp3")}
                        >
                            <PlayersSolutionCardsMolecule selectedCard={solutionCard} cardDimentions={cardDimentions} proposedCardOrder={index+1} />
                        </div>
                    )
                })}
            </div>
        );
    }

    return (
        <div className="question_picked cursor-pointer">
            {!(game?.phase === Phase.QUESTION_CARD && !isDilemmaChosen) && <ChosenDilemmaCard isTheFullScreenOn={true} /> }
            {renderProposedSolutions()}
        </div>
    );
}
const RenderQuestionToDisplay = React.memo(RenderQuestionToDisplayMemo);

export default RenderQuestionToDisplay; 
